import { render, staticRenderFns } from "./CommonLogoSpinner.vue?vue&type=template&id=6c5706fc"
import script from "./CommonLogoSpinner.vue?vue&type=script&lang=js"
export * from "./CommonLogoSpinner.vue?vue&type=script&lang=js"
import style0 from "./CommonLogoSpinner.vue?vue&type=style&index=0&id=6c5706fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports